exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".minor-graph[data-v-c7754d40] {\n  padding-bottom: 10px;\n  position: initial !important;\n}", ""]);

// exports
